import * as React from "react";
import { useCallback } from "react";
import { Button } from "baseui/button";
import { useSelector } from "react-redux";
// import { useStyletron } from "baseui";
import { FormControl } from "baseui/form-control";
import { useLocation } from "react-router-dom";
import { Input } from "baseui/input";
import { Select } from "baseui/select";
import { Textarea } from "baseui/textarea";
import axios from "axios";
//INITIAL_INSPECTION SECTIONS, OBJECT
import { InitialInspectionForm } from "./initial_inspection_form/initiInspectSections";
// import { is } from "date-fns/locale";

function VehicleUpdateForm({
  stockNum = null,
  setIsModalOpen,
  fromIncomingTable,
}) {
  // console.log("received fromIncomingTable", fromIncomingTable);
  // console.log("stock rec'd VUF", stockNum);
  const state = useSelector((state) => state);
  // console.log("state", state);

  const location = useLocation();
  // const isOnInspectionsPage = location.pathname === "/inspections";
  const isOnVehicleUpdatePage = location.pathname === "/vehicleUpdate";

  // const locationsMap = {
  //   1: "S01_Holmes1",
  //   2: "S09_Douglas1",
  //   3: "S05_Montgomery1",
  //   4: "S07_Bham1",
  // };

  let locationData = localStorage.getItem("location");

  let userLocation = null;

  try {
    const parsed = JSON.parse(locationData);
    if (Array.isArray(parsed) && parsed.length > 0 && parsed[0]?.id) {
      // userLocationId = parsed[0].id;
    } else {
      console.warn("Parsed location is invalid or empty:", parsed);
    }
  } catch (e) {
    console.error("Failed to parse location from localStorage:", e);
  }

  
  // let userLocation = locationsMap[userLocationId];

  const userId = useSelector((state) => state.user.id);
  const userRole = useSelector((state) => state.user.role_id);
  // const [css] = useStyletron();
  const apiUrl = process.env.REACT_APP_API_URL;

  const [steps, setSteps] = React.useState([]);
  const [filteredSteps, setFilteredSteps] = React.useState([]);
  const [filteredSteps2, setFilteredSteps2] = React.useState([]);
  const [filteredSteps3, setFilteredSteps3] = React.useState([]);
  const [repairStepsAdmin, setRepairStepsAdmin] = React.useState([]);

  // console.log("userRole", userRole);

  // console.log("filteredSteps2", filteredSteps2);

  const [users, setUsers] = React.useState([]);

  const [data, setData] = React.useState([]);
  const [inspections, setInspections] = React.useState([]);
  const [customers, setCustomers] = React.useState([]);
  // const [initial_inspections, setInitial_Inspections] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [suggestedStep, setSuggestedStep] = React.useState("");

  const [isInitInspection, setIsInitInspection] = React.useState(false);
  const [isInProgress, setIsInProgress] = React.useState(false);
  const [currentSection, setCurrentSection] = React.useState("");

  // Update form state
  const [updateForm, setUpdateForm] = React.useState({
    userId: userId,
    vehicleId: null,
    custRepairId: null,
    vehicleStock: "",
    location: "",
    inspectionType: "",
    serviceDescription: "",
    nextStatus: "",
    date: "",
  });

  // React.useEffect(() => {
  //   console.log("updateForm current", updateForm);
  // }, [updateForm]);

  const [stockString, setStockString] = React.useState("");
  const [resultString, setResultString] = React.useState("");
  const [serviceString, setServiceString] = React.useState("");
  const [descriptionString, setDescriptionString] = React.useState("");
  const [nonStep, setNonStep] = React.useState(false);
  const [lastInspection, setLastInspection] = React.useState({});
  const [lastInitInspection, setLastInitInspection] = React.useState({});
  const [lastInitId, setLastInitId] = React.useState();
  const [matchingObject, setMatchingObject] = React.useState({});
  const [repairJob, setRepairJob] = React.useState(false);
  const hasFetchedRef = React.useRef(false);

  const fetchSteps = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/steps`);
      const sortedSteps = response.data.steps
        .map((step) => ({
          id: step.id,
          label: step.step_name,
        }))
        .sort((a, b) => a.id - b.id);

      // console.log("sortedSteps", sortedSteps);

      // Leave off the last 4 steps
      // const stepsWithout1OrLast5 = sortedSteps.slice(1, -5);
      const stepsWithout1OrLast5 = [
        ...sortedSteps.slice(1, 9), // Elements from index 1 to 8 (qual contr to key line)
        sortedSteps[13], // Element at index 13
        ...(userRole === 2 ? [sortedSteps[20]] : []), // Conditionally include index 20
      ];

      // console.log("stepsWithout1OrLast5", stepsWithout1OrLast5);
      const stepsWithoutLast11 = sortedSteps.slice(0, -11); //-6?
      // console.log("stepsWithoutLast6", stepsWithoutLast11);
      const repairSteps = sortedSteps.slice(-6, -2);
      const repairStepsAdmin = sortedSteps.slice(-6);

      // Update the state with the new array
      // setFilteredSteps(stepsWithoutLast4);
      setFilteredSteps(stepsWithout1OrLast5);
      setFilteredSteps2(stepsWithoutLast11);
      setRepairStepsAdmin(repairStepsAdmin);
      setFilteredSteps3(repairSteps);
      setSteps(sortedSteps);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [apiUrl, userRole]);

  //FETCHING INVENTORY
  const fetchInventory = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/admin/vehicle/list`);
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [apiUrl]);

  //FETCH INSPECTIONS
  const fetchInspections = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/inspections`);
      setInspections(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [apiUrl]);

  const fetchCustomers = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/customers`);
      setCustomers(response.data.customers);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [apiUrl]);

  const fetchUsers = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/users/list`);
      setUsers(response.data.users);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [apiUrl]);

  React.useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;

    const loadAllData = async () => {
      await Promise.all([
        fetchSteps(),
        fetchInventory(),
        fetchInspections(),
        fetchCustomers(),
        fetchUsers(),
      ]);
      setLoading(false);
    };

    loadAllData();
  }, [fetchSteps, fetchInventory, fetchInspections, fetchCustomers, fetchUsers]);

  //SECTION INCREMENT (FOR SUBMIT HANDLER)
  const sectionIncr = (currentSection) => {
    let nextSection = "";

    if (currentSection === 11) {
      nextSection = "exterior";
    } else if (currentSection === 12) {
      nextSection = "underhood";
    } else if (currentSection === 13) {
      nextSection = "interior";
    }

    // Find the ID of the next section
    const nextStepObj = steps.find((step) => step.label === nextSection);

    if (nextStepObj) {
      setCurrentSection(nextSection);
      return nextStepObj.id; //returns new section steps .id
    } else {
      console.error("Next section not found in steps");
      return null;
    }
  };

  function dateFormatter(dateString) {
    const date = new Date(dateString);
    // Format the date to 'month day, year, time'
    const formattedDate = date.toLocaleString("en-US", {
      month: "long", // Full month name
      day: "numeric", // Numeric day
      year: "numeric", // Full year
      hour: "numeric", // Numeric hour
      minute: "numeric", // Numeric minute
      hour12: true, // 12-hour format with AM/PM
    });
    return formattedDate;
  }

  /// HANDLE SEARCH STOCK (triggered w'stockString' useState when btn clicked) something here
  // console.log("inspections", inspections);
  // console.log("updateForm", updateForm);
  // console.log("steps", steps);
  // console.log("customers", customers);

  const handleSearchStock = useCallback((stockNum) => {
    const findVehicle = (searchStock) => {
      let match = data.find(
        (item) => item.stock.toLowerCase() === searchStock.toLowerCase()
      );
      if (!match) {
        if (state.user.role_id === 2) {
          match = customers.find(
            (item) => item.StockNbr.toLowerCase() === searchStock.toLowerCase()
          );
        } else if (fromIncomingTable) {
          match = customers.find(
            (item) => item.StockNbr.toLowerCase() === searchStock.toLowerCase()
          );
        } else return;
      }
      return match;
    };

    if (!data || data.length === 0 || !customers || customers.length === 0) {
      alert("Vehicle data not available.");
      return;
    }

    const searchStock = stockNum || stockString;
    let finalMatch = findVehicle(searchStock);
    // console.log("finalMatch", finalMatch);

    if (!finalMatch) {
      alert("No vehicles found with the given stock number.");
      setResultString("");
      return;
    }

    const isRepairJob = finalMatch.hasOwnProperty("StockNbr");
    setRepairJob(isRepairJob);
    setMatchingObject(finalMatch);

    if (finalMatch.init_paused) {
      //if vehicle.init_paused = true, get the .init_inspect (initInspect id) of the last init inspection  in inspections, (saved as lastInitId)
      const lastInitInspection = inspections
        .filter(
          (insp) =>
            insp.inventory_id === finalMatch.id &&
            [1, 11, 12, 13, 14].includes(insp.step_id)
        )
        .slice(-1)[0]; // Get the last item in the filtered array
      setLastInitInspection(lastInitInspection);

      // If an inspection was found, use its 'init_inspect' value to setLastInitId
      if (lastInitInspection) {
        console.log(" THIS : lastInitInspection", lastInitInspection);
        setLastInitId(lastInitInspection.init_inspect); //also getting last init inspection obj instance's 'init_inspect' value (to be used to UPDATE EXISTING init Inspections record - to be used in handler)
      } else {
        console.log("No matching inspection found.");
      }
    }

    setUpdateFormForMatch(finalMatch, isRepairJob);

    // console.log("updateForm", updateForm);

    setResultString(generateResultString(finalMatch, isRepairJob));

    const lastInspection = findLastInspection(finalMatch.id, isRepairJob);
    console.log("lastInspection", lastInspection);
    setLastInspection(lastInspection);

    if (lastInspection) {
      handleInspectionStatus(lastInspection, finalMatch, isRepairJob);
      updateServiceString(lastInspection);
    } else {
      // console.log("finalMatch", finalMatch);
      handleNoInspectionStatus(finalMatch, isRepairJob);
    }
  }, [data, customers, inspections, stockString, state.user.role_id, fromIncomingTable, steps, users]);

  // Helper Functions

  const setUpdateFormForMatch = (match, isRepairJob) => {
    if (isRepairJob) {
      setUpdateForm((prevForm) => ({
        ...prevForm,
        custRepairId: match.id,
        inspectionType: match.cust_app_status,
        vehicleStock: match.StockNbr,
        location: userLocation,
      }));
    } else {
      setUpdateForm((prevForm) => ({
        ...prevForm,
        vehicleId: match.id,
        vehicleStock: match.stock,
        location: match.location,
      }));
    }
  };

  const generateResultString = (match, isRepairJob) => {
    return isRepairJob
      ? `${match.Year} ${match.Make} ${match.Model} (${match.Color}), stock: ${match.StockNbr}, vin: ${match.VIN}`
      : `${match.year} ${match.make} ${match.model} (${match.color}), stock: ${match.stock}, vin: ${match.vin}`;
  };

  const findLastInspection = (vehicleId, isRepairJob) => {
    return inspections
      .filter((insp) =>
        isRepairJob
          ? insp.custRepairId === vehicleId
          : insp.inventory_id === vehicleId
      )
      .slice(-1)[0];
  };

  const handleInspectionStatus = (lastInspection, match, isRepairJob) => {
    const lastStatus = lastInspection.next_status;
    const matchedStep = steps.find((step) => step.id === lastStatus);

    if (needsNewInitialInspection(lastInspection)) {
      startNewInitialInspection();
    } else if ([11, 12, 13, 14].includes(lastStatus)) {
      continueInProgressInspection(matchedStep);
    } else {
      resumePreviousStep(matchedStep);
    }
  };

  const needsNewInitialInspection = (lastInspection) => {
    const oneYearInMs = 365 * 24 * 60 * 60 * 1000;
    return new Date() - new Date(lastInspection.inspection_date) > oneYearInMs;
  };

  const startNewInitialInspection = () => {
    setIsInProgress(true);
    setSuggestedStep(steps.find((step) => step.id === 11).label);
    setIsInitInspection(true);
    setCurrentSection("roadtest");
    setUpdateForm((prevForm) => ({
      ...prevForm,
      inspectionType: steps.find((step) => step.id === 11).id,
    }));
  };

  const continueInProgressInspection = useCallback((matchedStep) => {
    setIsInProgress(true);
    setSuggestedStep(steps[0].label);
    setIsInitInspection(true);
    setCurrentSection(matchedStep ? matchedStep.label : "");
    setUpdateForm((prevForm) => ({
      ...prevForm,
      inspectionType: steps[0].id,
    }));
  }, [steps]);

  // const handleInspectionStatus = useCallback((lastInspection, match, repairJob) => {
  //   const lastStatus = lastInspection.next_status;
  //   const matchedStep = steps.find((step) => step.id === lastStatus);

  //   if (needsNewInitialInspection(lastInspection)) {
  //     startNewInitialInspection();
  //   } else if ([11, 12, 13, 14].includes(lastStatus)) {
  //     continueInProgressInspection(matchedStep);
  //   } else {
  //     resumePreviousStep(matchedStep);
  //   }
  // },[steps, startNewInitialInspection, continueInProgressInspection]);

  const resumePreviousStep = (matchedStep) => {
    setIsInProgress(false);
    setIsInitInspection(false);
    setSuggestedStep(matchedStep ? matchedStep.label : "");
    setCurrentSection("");
    setUpdateForm((prevForm) => ({
      ...prevForm,
      inspectionType: matchedStep ? matchedStep.id : "",
    }));
  };

  const updateServiceString = useCallback((lastInspection) => {
    const user = users.find((u) => u.id === lastInspection.inspector_id);
    const inspectorName = user
      ? `${user.first_name} ${user.last_name}`
      : "Unknown Inspector";
    const formattedDate = dateFormatter(lastInspection.inspection_date);
    const last_type = steps.find((step) => step.id === lastInspection?.step_id);

    setServiceString(
      `LAST SERVICED: ${formattedDate} | TYPE: ${
        last_type?.label || "Unknown"
      } | BY: ${inspectorName}`
    );
  }, [steps, users]);

  const handleNoInspectionStatus = (match, isRepairJob) => {
    console.log("handleNoInspectionStatus was run");
    const invStatus = isRepairJob
      ? steps.find((step) => step.id === match.cust_app_status)?.label ||
        match.status
      : steps.find((step) => step.id === match.app_status)?.label ||
        match.status;

    setSuggestedStep(invStatus);
    setNonStep(true);

    if (
      !isRepairJob &&
      [
        "Initial_Inspection",
        "roadtest",
        "exterior",
        "underhood",
        "interior",
      ].includes(invStatus)
    ) {
      startNewInitialInspection();
    } else {
      setIsInitInspection(false);
      setIsInProgress(false);
      setCurrentSection("");
      setUpdateForm((prevForm) => ({
        ...prevForm,
        inspectionType:
          steps.find((step) => step.label === invStatus)?.id || invStatus,
      }));
    }
  };

  React.useEffect(() => {
    if (
      !loading &&
      stockNum && //when VUF is invoked from IncomingTable Modal (gets passed 'stockNum')
      data &&
      data.length > 0 &&
      inspections && //p[robably don't need this]
      inspections.length > 0 && //not allowing handleSeachStock to run... do I need this to have content for other use?
      customers &&
      customers.length > 0 &&
      users &&
      users.length > 0
    ) {
      handleSearchStock(stockNum);
    }
  }, [loading, stockNum, data, customers, inspections, users, handleSearchStock]);

  // INSPECTION TYPE CHANGE
  const handleTypeChange = (params) => {
    const selectedType = params.value[0]?.label || ""; // Assuming 'label' is the property holding the type name

    console.log("selectedType", selectedType);

    // Update the form with the selected inspectionType (id)
    setUpdateForm({
      ...updateForm,
      inspectionType: params.value[0]?.id || "",
    });

    // Check if the selected value is not "Initial_Inspection" and update the state accordingly
    if (selectedType !== "Initial_Inspection") {
      setIsInitInspection(false);
    } else {
      setIsInitInspection(true);
      console.log("isInProgress", isInProgress); //false
      setCurrentSection("roadtest");
    }
  };

  console.log("lastInitInspection", lastInitInspection);
  const [isPauseReturn, setIsPauseReturn] = React.useState(false);

  const handleStepChange = (params, isPaused) => {
    console.log("params", params);
    console.log("isPaused", isPaused);

    // console.log("lastInitInspection", lastInitInspection);
    if (isPaused && lastInitInspection) {
      // Logic when init_paused is true and there is a lastInitInspection
      setIsPauseReturn(true);
      setUpdateForm({
        ...updateForm,
        nextStatus:
          params.value[0]?.id === 1
            ? lastInitInspection.step_id
            : params.value[0]?.id,
      });
    } else if (!isPaused) {
      // Logic when init_paused is false (second return)
      if (params.value[0]?.id === 1) {
        // If they select 'initial_inspection', set nextStatus to 15
        setUpdateForm({
          ...updateForm,
          nextStatus: 15,
        });
      } else {
        // Otherwise, set the nextStatus to the selected step ID
        setUpdateForm({
          ...updateForm,
          nextStatus: params.value[0]?.id || "",
        });
      }
    } else {
      // Regular step change when paused but no lastInitInspection or other case
      setUpdateForm({
        ...updateForm,
        nextStatus: params.value[0]?.id || "",
      });
    }
  };

  const clearForm = (event) => {
    setUpdateForm((prevState) => ({
      userId: prevState.userId,
      vehicleId: prevState.vehicleId,
      vehicleStock: prevState.vehicleStock,
      location: prevState.location,
      inspectionType: "",
      serviceDescription: "",
      nextStatus: "",
      date: "",
      init_inspect: "",
    }));

    setDescriptionString("");

    setSuggestedStep("");
    event.preventDefault();
  };

  //UNSELECTS CAR
  const exitForm = (event) => {
    setUpdateForm((prevState) => ({
      userId: prevState.userId,
      vehicleId: "",
      vehicleStock: "",
      location: "",
      inspectionType: "",
      serviceDescription: "",
      nextStatus: "",
      date: "",
      init_inspect: "",
    }));

    setStockString("");
    setDescriptionString("");
    setResultString("");
    setSuggestedStep("");
    fetchInventory();
    fetchInspections();
  };

  let finalForm;
  console.log("isInProgress", isInProgress);
  console.log("repairJob", repairJob);

  /// /////////////    HANDLE SUBMIT CLICK   ///////////////
  const handleSubmitClick = async (
    event,
    init, //11
    initInspectId,
    sectionNotes,
    chosenSection, // 3
    full_init //false
  ) => {
    event.preventDefault();
    const now = new Date();
    const offset = now.getTimezoneOffset(); // offset in minutes
    now.setMinutes(now.getMinutes() - offset); // Adjust to local time
    const currentDateTime = now.toISOString().slice(0, 19).replace("T", " ");
    // Create a copy of updateForm
    finalForm = {
      ...updateForm,
      date: currentDateTime,
    };
    console.log("updateForm", updateForm);
    console.log("finalForm", finalForm);

    let isInProgress;
    // INIT INSPECTIONS SUBMITS ONLY--
    if (initInspectId) {
      //as long as 'Wholesale' is not the chosenSection (which should make it so that isInProgress is FALSE - not paused)
      if (
        (init === 11 || init === 12 || init === 13 || init === 14) &&
        chosenSection !== 22
      ) {
        isInProgress = true;
      } else {
        isInProgress = false;
      }
    } else {
      isInProgress = false;
    }

    const matchedStep =
      !isPauseReturn && isInProgress
        ? steps.find((step) => step.id === init)
        : steps.find((step) => step.id === updateForm.inspectionType); //step object {id:1 label: ""}

    // let usableNextStatus;

    finalForm = {
      ...finalForm,
      ...(init !== 1 &&
        !isPauseReturn &&
        isInProgress && { inspectionType: init }), // this is working

      serviceDescription: `${(matchedStep?.label || "Unknown").toUpperCase()}${
        chosenSection && !full_init
          ? " (PAUSED)"
          : init === 14
          ? isPauseReturn
            ? ""
            : ` (Initial Inspection Complete)`
          : ""
      }, ${sectionNotes ? sectionNotes : descriptionString}`,

      nextStatus: isInProgress
        ? chosenSection
          ? chosenSection
          : `${sectionIncr(init)}`
        : init === 1
        ? 11
        : chosenSection && init === 14
        ? chosenSection
        : init, // 1
      init_inspect: initInspectId,
    };

    setIsInProgress(isInProgress);
    setIsInitInspection(isInProgress);

    const { vehicleId, nextStatus } = finalForm; // 997, 4
    console.log("finalForm", finalForm);

    // //////////////////// INSPECTIONS UPDATE ///////////////////////////
    try {
      const response = await axios.post(`${apiUrl}/api/inspections`, finalForm);
      if (response.status === 200) {
        alert("Inspection inserted successfully");
      } else {
        alert("Failed to insert inspection");
      }
    } catch (error) {
      console.error("Error inserting inspection:", error);
      alert("Error while inserting inspection");
    }

    // // // // // ///////////    INVENTORY: UPDATE vehicle.app_status, .init_paused  /////////////////

    if (repairJob) {
      try {
        const updateCustomerResponse = await axios.put(
          `${apiUrl}/api/customer/${finalForm.custRepairId}`,
          { nextStatus: finalForm.nextStatus } // Send nextStatus in the request body
        );

        if (updateCustomerResponse.status === 200) {
          alert("Vehicle status updated successfully");
        } else {
          alert("Failed to update vehicle status");
        }
      } catch (error) {
        console.error("Error updating vehicle status:", error);
        alert("Error while updating vehicle status");
      }

      // POST-SUBMIT CHANGES TO UPDATE FORM
      if (!isInProgress) {
        exitForm();
        if (setIsModalOpen) {
          setIsModalOpen(false);
        }
      }
    } else {
      let updateData;
      updateData = {
        app_status: nextStatus === 1 ? 11 : nextStatus, //if

        ...(chosenSection !== undefined
          ? {
              init_paused:
                nextStatus === 1
                  ? 0
                  : stockNum && isInProgress
                  ? full_init
                    ? 0
                    : 1
                  : 0,
            }
          : {
              //submitting back
              init_paused:
                isInProgress && !full_init ? 1 : isPauseReturn ? 1 : 0,
            }),
      };
      console.log("updateData", updateData);
      try {
        const updateInventoryResponse = await axios.put(
          `${apiUrl}/api/inventory/${vehicleId}`,
          updateData
        );

        if (updateInventoryResponse.status === 200) {
          alert("Vehicle status updated successfully");
        } else {
          alert("Failed to update vehicle status");
        }
      } catch (error) {
        console.error("Error updating vehicle status:", error);
        alert("Error while updating vehicle status");
      }

      //POST-SUBMIT CHANGES TO UPDATE FORM
      if (isInProgress === false) {
        exitForm(); //<-------
        // setIsModalOpen(false);
        if (setIsModalOpen) {
          setIsModalOpen(false);
        }
      }
    }
  };

  console.log("stockString", stockString);

  return (
    <form
      onKeyDown={(event) => event.key === "Enter" && event.preventDefault()}
    >
      <h1>
        {!fromIncomingTable && state.user.role_id === 2
          ? repairJob
            ? "Repair Assignment Form"
            : stockNum === null
            ? isOnVehicleUpdatePage
              ? "Vehicle Update Form"
              : "Repair Assignment Form"
            : "Vehicle Update Form"
          : "Vehicle Update Form"}
      </h1>

      <FormControl>
        <>
          {resultString ? (
            <>
              <h2 style={{ color: "#3cb371", width: "100%" }}>
                <span style={{ color: "black", textDecoration: "underline" }}>
                  Selected Vehicle:
                </span>{" "}
                {resultString}
              </h2>
              <h3>{serviceString}</h3>
              <h3
                style={{
                  display: "inline",
                }}
              >
                DESCRIPTION:{" "}
              </h3>
              <h4
                style={{
                  display: "inline",

                  fontWeight: "300",
                  color: "darkcyan",
                }}
              >
                {" "}
                {lastInspection && lastInspection.description}
              </h4>
            </>
          ) : (
            <h2 style={{ color: "black", textDecoration: "underline" }}>
              {/* {!fromIncomingTable && state.user.role_id === 2
                ? repairJob
                  ? "Customer Vehicle"
                  : !fromIncomingTable
                  ? "Selected Vehicle"
                  : stockNum === null
                  ? "Customer Vehicle"
                  : "Selected Vehicle"
                : null} */}
              {!fromIncomingTable && state.user.role_id === 2
                ? repairJob
                  ? "Customer Vehicle"
                  : stockNum === null
                  ? isOnVehicleUpdatePage
                    ? "Selected Vehicle"
                    : "Customer Vehicle"
                  : "Selected Vehicle"
                : null}
            </h2>
          )}
          {/* SEARCH BLANK */}
          <Input
            style={{
              marginTop: ".5rem",
            }}
            clearable
            disabled={stockNum !== null}
            //check stockNum, if exists, make search input disabled
            placeholder={loading ? "Loading Data..." : "Stock #"}
            value={stockString || updateForm.vehicleStock}
            onChange={(event) => setStockString(event.target.value)}
          />
          {/* SEARCH BTN */}
          <Button
            style={{ marginTop: "1rem", backgroundColor: "green" }}
            type="button"
            onClick={() => handleSearchStock(stockString)}
            disabled={
              loading ||
              (updateForm.vehicleId !== "" &&
                updateForm.vehicleStock !== "" &&
                updateForm.location !== "")
            }
          >
            Search Stock
          </Button>
          {/* CLEAR SEARCH INPUT BTN */}
          <Button
            style={{
              marginTop: "1rem",
              marginLeft: "1rem",
              backgroundColor: "#ff5347",
            }}
            type="button"
            onClick={() => {
              // Manual clear functionality
              setStockString("");
              setSuggestedStep("");
              setUpdateForm((prevForm) => ({
                ...prevForm,
                vehicleId: "",
                vehicleStock: "",
                location: "",
                inspectionType: "",
              }));
              setResultString("");
              // setSearchDisabled(false); // Re-enable the search button if it was disabled
              setIsInitInspection(false);
              // setInitInspectionInvId("");
            }}
            disabled={stockNum !== null}
          >
            Clear Input
          </Button>
        </>
      </FormControl>
      {/* <FormControl label="What type of inspection is being performed? (NOTE: suggested step is currently ${suggestedStep}"> */}

      <FormControl
        label={`What type of inspection is being performed? (NOTE: ${
          nonStep
            ? `current status: ${suggestedStep}` //different verbiage '
            : `suggested step: ${suggestedStep}`
        })`}
      >
        <Select
          options={repairJob ? filteredSteps3 : filteredSteps}
          value={steps.filter((step) => step.id === updateForm.inspectionType)}
          placeholder="Select Inspection Type"
          onChange={handleTypeChange}
          disabled={
            isInProgress ||
            stockNum != null ||
            matchingObject.cust_app_status === 21 ||
            matchingObject.app_status === 15
              ? true
              : false
          }
        />
      </FormControl>

      {isInitInspection ? (
        <InitialInspectionForm
          vehicleId={updateForm.vehicleId}
          currentSection={currentSection}
          setCurrentSection={setCurrentSection}
          handleSubmitClick={handleSubmitClick}
          origin="vehicleUpdate"
          initPaused={matchingObject.init_paused}
          lastInitId={lastInitId}
          setIsModalOpen={setIsModalOpen}
          steps={steps}
          filteredSteps={filteredSteps}
        />
      ) : (
        <>
          <FormControl label="Describe work performed below:">
            <Textarea
              id="service-description-id"
              value={descriptionString}
              onChange={(event) =>
                setDescriptionString(event.currentTarget.value)
              }
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.stopPropagation(); // Ensure the event doesn't propagate to higher levels
                }
              }}
            />
          </FormControl>

          {matchingObject.init_paused === 1 ? (
            // Render the first version when init_paused is true
            //if it's paused it gets the added option of 'initial_inspections' for next_status (filteredOptions2)

            <FormControl
              label={`Send To: (NOTE: Initial Inspection currently incomplete)`}
            >
              <Select
                options={filteredSteps2} // Use filteredSteps directly as options
                value={filteredSteps2.filter(
                  (step) => step.id === updateForm.nextStatus
                )}
                // disabled={matchingObject.app_status === 15 ? true : false}
                placeholder={
                  updateForm.nextStatus === 11
                    ? "roadtest"
                    : updateForm.nextStatus === 12
                    ? "exterior"
                    : updateForm.nextStatus === 13
                    ? "underhood"
                    : updateForm.nextStatus === 14
                    ? "interior"
                    : "" // default placeholder if no condition matches
                }
                onChange={(params) => handleStepChange(params, true)}
              />
            </FormControl>
          ) : (
            // Render the second version when init_paused is false
            <FormControl label="Where is vehicle going next?">
              {repairJob ? (
                <Select
                  options={
                    state.user.role_id === 2
                      ? // Check if `cust_app_status` is 21 (assign_repair)
                        matchingObject.cust_app_status === 21
                        ? //sliced
                          repairStepsAdmin
                            .slice(0, -3) // Remove the last two items from `repairStepsAdmin`
                            .filter(
                              (step) => step.id !== updateForm.inspectionType
                            )
                        : //unsliced
                          repairStepsAdmin
                            .slice(0, -1)
                            .filter(
                              (step) => step.id !== updateForm.inspectionType
                            )
                      : // For other roles, check if `cust_app_status` is 21
                      matchingObject.cust_app_status === 21
                      ? filteredSteps3
                          .slice(0, -1) // Remove the last item from `filteredSteps3`
                          .filter(
                            (step) => step.id !== updateForm.inspectionType
                          )
                      : filteredSteps3.filter(
                          (step) => step.id !== updateForm.inspectionType
                        )
                  }
                  value={steps.filter(
                    (step) => step.id === updateForm.nextStatus
                  )}
                  placeholder="Select Next Step"
                  onChange={(params) => handleStepChange(params, false)}
                />
              ) : (
                //if NOT a repair
                <Select
                  // options={filteredSteps}
                  options={filteredSteps.filter(
                    (step) => step.id !== updateForm.inspectionType
                  )}
                  value={steps.filter(
                    (step) => step.id === updateForm.nextStatus
                  )}
                  placeholder="Select Next Step"
                  onChange={(params) => handleStepChange(params, false)}
                />
              )}
            </FormControl>
          )}

          <Button
            style={{ marginRight: "1rem", backgroundColor: "green" }}
            type="submit"
            // onClick={handleSubmitClick}
            onClick={(event) => handleSubmitClick(event, updateForm.nextStatus)}
          >
            Submit Form
          </Button>
          {!stockNum && (
            <Button
              style={{ backgroundColor: "orange", marginRight: "1rem" }}
              onClick={clearForm}
            >
              Clear Form
            </Button>
          )}
          <Button style={{ backgroundColor: "#ff5347" }} onClick={exitForm}>
            Exit Form
          </Button>
        </>
      )}
    </form>
  );
}

export default VehicleUpdateForm;
